// eslint-disable-next-line monorepo-dependencies/no-unlisted-package-import
import { PlayerManager } from 'chromecast-caf-receiver/cast.framework';
import { bootstrapAction, mediaFilter } from '../extensions';
import cast from '../../types/chromecast-caf-receiver/index';

export class DisableLiveSeekPlugin {
  playerManager: PlayerManager;

  init() {
    bootstrapAction.register(async ctx => {
      this.playerManager = ctx.getPlayerManager();
    });
    mediaFilter.register(async media => {
      if (media.metadata.isLive) {
        // Disable SEEK when live
        this.playerManager.removeSupportedMediaCommands(cast.framework.messages.Command.SEEK);
      } else {
        this.playerManager.addSupportedMediaCommands(cast.framework.messages.Command.SEEK);
      }
      return media;
    });
  }
}
